import axiosInstance from 'services/axiosMiddleware';

export async function verifyEmailOtp(payload) {
  console.log('sending payload:', payload); // full registration + OTP
  try {
    const response = await axiosInstance.post('auth/validateemailotp', payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
